export default "__VITE_ASSET__CGU3boWK__"